<template>
  <div ref="header" class="d1" role="banner">
    <div class="d2">
      <img ref="logo" alt="Mailbox with a hand reachout out of it" src="../assets/logo.png" :class="['logo','link']" @click="this.$router.push('/home');"/>
    </div>
    <div class="d3" v-if="!isMobile">
      <ul class="nav" role="navigation">
        <li> <a :class="[selected==='home'?'navLine':'', 'link']" @click="this.$router.push('/home');">Home</a></li>
        <li> <a :class="[selected==='about'?'navLine':'', 'link']" @click="this.$router.push('/about');">About Us</a></li>
        <li> <a :class="[selected==='citymap'?'navLine':'', 'link']" @click="this.$router.push('/citymap');">City Maps</a></li>
        <li> <a :class="[selected==='privacypolicy'?'navLine':'', 'link']" @click="this.$router.push('/privacypolicy');">Privacy Policy</a></li>
      </ul>
    </div>
    <div class="d4" v-if="!isMobile">
      <div :class="['btn','link']" @click="this.$router.push('/contact');">Contact Us</div>
    </div>
    <transition name="menu">
      <div v-if="isMobile && showMenu" class="m1" v-click-outside="onClickOutside">
        <router-link :to="{name: 'home', query: {id: 'home' }}" @click="showMenu=false; this.$router.push('/home')"  :class="selected==='home'? 'underlineText' : 'removeUnderline'" >Home</router-link>   
        <router-link :to="{name: 'about', query: {id: 'about' }}" @click="showMenu=false; this.$router.push('/about')" :class="selected==='about' ? 'underlineText' : 'removeUnderline'" >About</router-link> 
        <router-link :to="{name: 'citymap', query: {id: 'citymap' }}" @click="showMenu=false; this.$router.push('/citymap')" :class="selected==='citymap' ? 'underlineText' : 'removeUnderline'">City Map</router-link>           
        <router-link :to="{name: 'privacypolicy', query: {id: 'privacypolicy'}}" @click="showMenu=false; this.$router.push('/privacypolicy')" :class="selected==='privacypolicy' ? 'underlineText' : 'removeUnderline'">Privacy Policy</router-link>
        <router-link :to="{name: 'contact', query: {id: 'contact'}}" @click="showMenu=false; this.$router.push('/contact');" :class="[selected==='contact' ? 'underlineText' : 'removeUnderline', 'contactUs']">Contact Us</router-link>          
      </div>
    </transition>        
    <!-- <div v-if="isMobile" class="d5">    -->
      <div v-if="isMobile" class="menuBtn" @click="showMenu=true">Menu</div>
    <!-- </div>       -->
  </div>
</template>

<script>
  export default {
    name: 'header',
    data() {
      return {
        viewh: 0,
        vieww: 0,
        d1h: 0,
        isMobile: false,
        showMenu: false,
      }
    },
    methods: {
      updateViewport() {
        this.viewh = window.innerHeight;
        this.vieww = window.innerWidth;
        this.d1h = this.viewh * .25 + 'px';
      },
      windowSize () {
        if (window.innerWidth <= 900) {
          this.isMobile = true
        } else {
          this.isMobile = false
        }
      },
      onClickOutside() {
        this.showMenu=false;
      },      
    },
    computed: {
      selected() {
        return this.$route.name;
      }
    },
    mounted() {
      this.windowSize();
      window.addEventListener('resize', this.windowSize);      

      this.updateViewport();
      window.addEventListener('resize', this.updateViewport);      
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.windowSize);
      window.addEventListener('resize', this.updateViewport);
    }
  }
</script>

<style scoped>
  .btn {
    /* position: fixed; */    
    color: v-bind(colorRed);
    font-family: 'Alata';
    font-size: 20px;
    border: 1px solid v-bind(colorRed);
    border-radius: 30px;
    padding: 8px;
    margin: 0;
    margin-right:35px;
    margin-top:35px;
    white-space: nowrap;
    width: fit-content;
    float:right;
  }
  .d1 {
    width:100%;
    display:flex;
    justify-content: space-between;
    min-height: 25vh;
    height:233px;
  }
  .d2 {
    width: 20%;
  }
  .d3 {
    display: flex;
    justify-content: center;    
    width: 60%;
  }
  .d4 {
    width: 20%;
  }
  .link:hover {
    cursor: pointer;
    color: v-bind(colorBlue5);
    border-color: v-bind(colorBlue5);
  }
  .logo {    
    width: 50%;
    
    margin-left: 35px;
    margin-top: 35px;
    /* max-height: calc(25vh - 35px); */
    object-fit: contain;
    border-radius: 10px;
  }
  .logo:hover {
    transform:scale(1.2);
  }
  .nav {
    display: flex;
    list-style-type:none;
    margin-top:35px;
    font-family: 'Alata', sans-serif;
    font-size: 20px;
    color: v-bind(colorRed);
    padding:0;
  }
  .nav > li {
    margin-left: 40px;
    margin-right: 40px;
  }
  .navLine {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
  @media only screen and (max-width: 900px) {
    .d1 {
      height: 190px;
    }
    .logo {
      /* width: 100%; */
      width: 100%;
    }
    .m1 {
      font-family: 'Arimo Hebrew Subset', sans-serif;
      position: fixed;
      width: 40%;
      height:100vh;
      right:0;
      background-color:v-bind(colorBlue3);
      z-index:100;
      border-left: 3px outset v-bind(colorBlue2);
      display: flex;
      flex-direction: column;
      overflow-y: scroll;      
      z-index: 1001;
    }
    .m1 * {
      color:white;
      padding: 10px;
      border-bottom: 2px solid v-bind(colorBlue2);
      text-decoration: none;
    }

    .m1 :first-child{
      border-top: 2px solid v-bind(colorBlue2);
      margin-top: 20px;
      text-decoration: none;
    }
    .menuBtn {  
      font-family: 'Arimo Hebrew Subset', sans-serif;
      font-size: 1.4em;
      color: v-bind(colorRed);
      position:absolute;
      right:35px;
      top: 52.5px;
      padding: 10px;
      border: 1px solid v-bind(colorRed);
      padding:5px;
      box-sizing:border-box;
      border-radius: 10px;
      background-clip:border-box;    

    }
    .menu-enter-from {
      transform: translateX(40vw);
    }
    .menu-enter-active {
      transition: all 0.5s ease-out;
    }
    .menu-leave-active {
      transition: all 0.5s ease-in;
    }
    .menu-leave-to {
      transform: translateX(40vw);
    }
    .underlineText {
      background-color: v-bind(colorBlue1);
    }
    .removeUnderline{
      background-color: unset;
    }
  }
  
</style>